import { EmailRegEx, WebsiteRegEx } from 'data/globalConstants';
import styles from 'styles/modules/SidescreenEditCompanyInfo.module.scss';
import Input from 'components/Input';
import AddContent from 'components/Profile/AddContent';
import { useState } from 'react';
import EditContent from 'components/Profile/EditContent';

import { common, profile, validation } from 'lang/en.json';
import Uploader from 'components/Uploader';
import Typo from 'components/Typo';

// Chrome ignores autocomplete="off" and fills the editor's saved contact; an unknown token stops it.
const noAutofill = 'no-autofill';

const Details = ({
    callback,
    register,
    errors,
    data,
    logoPreview,
    handleFile,
    isJournalist,
}) => {
    const [formData, setFormData] = useState(data);
    const [uploadPopupActive, setUploadPopupActive] = useState(false);

    const handleKeyUp = (name, val) => {
        let newFormData = JSON.parse(JSON.stringify(formData));
        newFormData[name] = val;
        setFormData(newFormData);
        callback(newFormData);
    };

    const handlePopupCancel = () => {
        setUploadPopupActive(false);
    };

    const inputs = [
        {
            label: common.name,
            name: 'name',
            color: 'dark',
            error: errors['name'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData.name,
            autoComplete: noAutofill,
        },
        {
            label: common.publication,
            name: 'publication',
            color: 'dark',
            error: errors['publication'],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.publication,
        },
        {
            label: profile.header.details.sidebar.website,
            name: 'website',
            color: 'dark',
            error: errors['website'],
            register: register({
                required: validation.required,
                pattern: {
                    value: WebsiteRegEx,
                    message: validation.website,
                },
            }),
            onKeyUp: handleKeyUp,
            value: formData.website,
        },
        {
            label: common.email,
            name: 'email',
            color: 'dark',
            error: errors['email'],
            register: register({
                required: validation.required,
                pattern: {
                    value: EmailRegEx,
                    message: validation.email,
                },
            }),
            onKeyUp: handleKeyUp,
            value: formData.email,
            autoComplete: noAutofill,
        },
        {
            label: common.phone,
            name: 'phone',
            color: 'dark',
            error: errors['phone'],
            register: register({
                required: validation.required,
            }),
            onKeyUp: handleKeyUp,
            value: formData.phone,
            autoComplete: noAutofill,
        },
        {
            label: 'Employer',
            name: 'employer',
            color: 'dark',
            error: errors['employer'],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.employer,
        },
        {
            label: 'Position',
            name: 'position',
            color: 'dark',
            error: errors['position'],
            register: register({}),
            onKeyUp: handleKeyUp,
            value: formData.position,
        },
    ];

    const handleClick = () => {
        setUploadPopupActive(true);
    };

    let button;

    if (logoPreview) {
        button = (
            <div className={styles.logoWrapper}>
                <img className={styles.companyLogo} src={logoPreview} />
                <div className={styles.logoEdit}>
                    <EditContent
                        data={{
                            onClick: handleClick,
                        }}
                    />
                </div>
            </div>
        );
    } else {
        button = (
            <div className={styles.bioLogoArea} onClick={handleClick}>
                <AddContent data={{ label: null }} />
            </div>
        );
    }

    return (
        <section className={styles.bio}>
            <Uploader
                isActive={uploadPopupActive}
                croppable={false}
                forceCrop={true}
                returnFile={true}
                onCancel={handlePopupCancel}
                onSubmit={(file) => {
                    handleFile(file);
                    setUploadPopupActive(false);
                }}
                allowedTypes={'images'}
            />

            <div className={styles.bioLogo}>
                <Typo variant={'body'} className={'mb-xxs'}>
                    {profile.header.details.sidebar.logo}
                </Typo>
                {button}
            </div>

            <div className={styles.bioBody}>
                {inputs.map((item, key) => {
                    if (isJournalist) {
                        if (
                            item.name !== 'phone' ||
                            (item.name === 'publication' && isJournalist)
                        ) {
                            return <Input {...item} key={`input-${key}`} />;
                        }
                    } else {
                        if (item.name !== 'publication') {
                            return <Input {...item} key={`input-${key}`} />;
                        }
                    }
                })}
            </div>
        </section>
    );
};

export default Details;
